// extracted by mini-css-extract-plugin
export default {"wrap":"QN-z","fullWidth":"RN-z","hideOnDesktop":"SN-z","content":"TN-z","hasOpenedNav":"UN-z","crumbsList":"VN-z","dropdownsWrap":"WN-z"};